import React from 'react'
import classNames from 'classnames'

import Paper from 'components/Paper'
import { Color } from 'themes/types'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ButtonBase from '@material-ui/core/ButtonBase'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'

import chevronRightIconUrl from './assets/icon_chevron_right.svg'

interface Props {
  className?: string
  color: Color,
  onClick?: () => void
  headline: React.ReactNode
  message: React.ReactNode
  disableArrow?: boolean
  animating?: boolean
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: theme.spacing() * 2,
  },
  '@keyframes BaseGameStatusBar-Flashing-Animation': {
    '50%': { opacity: 0 },
  },
  flashing: {
    animationName: '$BaseGameStatusBar-Flashing-Animation',
    animationDuration: '0.5s',
    animationIterationCount: 3,
  },
  messageContainer: {
    paddingLeft: theme.spacing() * 2,
    paddingRight: theme.spacing() * 2,
  },
  arrowIcon: {
    display: 'block',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const BaseGameStatusBar: React.SFC<InjectedProps> = ({
  className,
  classes,
  color,
  headline,
  message,
  animating,
  disableArrow,
  onClick,
}) => {
  const withButton = (component: JSX.Element) => {
    return onClick
      ? <ButtonBase onClick={() => onClick()} component="div" style={{ display: 'block' }}>{component}</ButtonBase>
      : component
  }

  return withButton(
    <Paper
      className={classNames(className, classes.root, { [classes.flashing]: animating })}
      color={color}
    >
      <Grid container alignItems="center">
        <Grid item>
          <Typography variant="body1" color="inherit">
            {headline}
          </Typography>
        </Grid>
        <Grid item className={classes.messageContainer}>
          <Typography variant="body2" color="inherit">
            {message}
          </Typography>
        </Grid>
        {!disableArrow && (
          <Grid container item xs justify="flex-end">
            <img alt="" className={classes.arrowIcon} src={chevronRightIconUrl} />
          </Grid>
        )}
      </Grid>
    </Paper>
  )
}

export default withStyles(styles)(BaseGameStatusBar)
